<template>
  <header id="app-header">
    <Nav></Nav>
  </header>
  <main id="app-main">
    <router-view></router-view>
  </main>
  <footer id="app-footer">
    <Footer></Footer>
  </footer>
</template>

<style lang="scss">
  @import "@/assets/scss/main";
  
  ::selection {
    background: darken($primary, 15%);
    color: #fff;
  }

  @include until($tablet) {
    html { font-size: 15px; }
  }

  #app-main {
    flex: 1;
    position: relative;
  }

  #app-header {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 5;
    border-top: 5px solid $primary;
  }
</style>

<script>
  import Nav from './views/snippets/Nav';
  import Footer from './views/snippets/Footer';

  export default {
    components: {
      Nav,
      Footer
    }
  }
</script>
